import React, { Fragment } from "react"
import { appTeamRoundPath } from "../App/paths"
import { Round, TeamRound } from "../types"
import { formatScore, thru } from "../util"

interface TeamLeaderboardProps {
  round: Round
  teamRounds: TeamRound[]
}

export default function TeamLeaderboard({ round, teamRounds }: TeamLeaderboardProps) {
  const startedTeamRounds = []
  const notStartedTeamRounds = []

  for (const tr of teamRounds) {
    if (tr.holesCompleted > 0) {
      startedTeamRounds.push(tr)
    } else {
      notStartedTeamRounds.push(tr)
    }
  }

  return (
    <>
      {startedTeamRounds.length > 0 ? <StartedTeams teamRounds={startedTeamRounds} /> : null}
      {notStartedTeamRounds.length > 0 ? <NotStartedTeams round={round} teamRounds={notStartedTeamRounds} /> : null}
    </>
  )
}

function goToTeamProfile(teamRoundId: number) {
  const backPath = `${window.location.pathname}${window.location.search}`
  window.location.href = appTeamRoundPath(teamRoundId, { back_path: backPath })
}

interface StartedTeamsProps {
  teamRounds: TeamRound[]
}

function StartedTeams({ teamRounds }: StartedTeamsProps) {
  return (
    <table style={{ width: "100%" }}>
      <thead>
        <tr>
          <th style={{ width: "1%", borderRight: "none" }}></th>
          <th style={{ width: "96%", borderLeft: "none", borderRight: "none" }}>Team</th>
          <th style={{ width: "1%", textAlign: "right", borderLeft: "none", borderRight: "none" }}>Score</th>
          <th style={{ width: "1%", textAlign: "right", borderLeft: "none", borderRight: "none" }}>Thru</th>
          <th style={{ width: "1%", textAlign: "right", borderLeft: "none" }}>Points</th>
        </tr>
      </thead>
      <tbody>
        {teamRounds.map((tr, i) => {
          return (
            <Fragment key={i}>
              <tr
                style={{ backgroundColor: i % 2 === 0 ? "#fff" : "#fafafa", cursor: "pointer" }}
                onClick={() => goToTeamProfile(tr.id)}
              >
                <td style={{ width: "1%", textAlign: "center", borderRight: "none" }}>{tr.position.label}</td>
                <td style={{ width: "96%", borderLeft: "none", borderRight: "none" }}>
                  <strong>{tr.name}</strong>
                  <br />
                  {tr.players.map((p) => p.user.name).join(" / ")}
                </td>
                <td style={{ width: "1%", textAlign: "right", borderLeft: "none", borderRight: "none" }}>
                  {formatScore(tr.netScoreRelativeToPar)}
                </td>
                <td style={{ width: "1%", textAlign: "right", borderLeft: "none", borderRight: "none" }}>
                  {thru(tr.holesCompleted, tr.complete)}
                </td>
                <td style={{ width: "1%", textAlign: "right", borderLeft: "none" }}>{tr.position.points}</td>
              </tr>
            </Fragment>
          )
        })}
      </tbody>
    </table>
  )
}

interface NotStartedTeamsProps {
  round: Round
  teamRounds: TeamRound[]
}

function NotStartedTeams({ round, teamRounds }: NotStartedTeamsProps) {
  return (
    <table style={{ width: "100%" }}>
      <thead>
        <tr>
          <th style={{ width: "1%", borderRight: "none" }}></th>
          <th style={{ width: "98%", borderLeft: "none", borderRight: "none" }}>Team</th>
          <th style={{ width: "1%", textAlign: "right", borderLeft: "none", whiteSpace: "nowrap" }}>
            {round.startType === "shotgun" ? "Start Hole" : "Tee Time"}
          </th>
        </tr>
      </thead>
      <tbody>
        {teamRounds.map((tr, i) => {
          return (
            <Fragment key={i}>
              <tr
                style={{ backgroundColor: i % 2 === 0 ? "#fff" : "#fafafa", cursor: "pointer" }}
                onClick={() => goToTeamProfile(tr.id)}
              >
                <td style={{ width: "1%", textAlign: "center", borderRight: "none" }}>{tr.position.label}</td>
                <td style={{ width: "98%", borderLeft: "none", borderRight: "none" }}>
                  <strong>{tr.name}</strong>
                  <br />
                  {tr.players.map((p) => p.user.name).join(" / ")}
                </td>
                <td style={{ width: "1%", textAlign: "right", borderLeft: "none" }}>
                  {tr.startGroup ? `${tr.startHoleNumber}${tr.startGroupLabel}` : tr.startTimeOfDay}
                </td>
              </tr>
            </Fragment>
          )
        })}
      </tbody>
    </table>
  )
}
